module.exports = __webpack_public_path__ + "img/userNameBgMob.c775c7b9.svg";